import { useGetPromptLibrary } from "@queries/chat/useGetPromptLibrary";
import type { PromptLibraryItem } from "@shared/apis/sidekick/generated";
import { QuickCategories, QuickCategoriesSkeleton } from "./QuickCategories";

type Props = {
  isSendingMessage: boolean;
  onItemClick: (item: PromptLibraryItem) => void;
};

export const ChatNewChatView = ({ isSendingMessage, onItemClick }: Props) => {
  const { isLoading, data } = useGetPromptLibrary();
  if (isLoading) return <QuickCategoriesSkeleton />;
  if (!data?.categories) return null;
  return (
    <QuickCategories
      categories={data.categories}
      disabled={isSendingMessage}
      onItemClick={onItemClick}
    />
  );
};
